<template>
  <div>
    <div class="container page-body">
      <!-- <h2>Images List Pending</h2>
      <div v-for="image in imagesList('Pending')" :key="image.id">
        {{ image.breed }} {{ image.caption }}
      </div> -->

      <div class="general-panel">
        <div class="general-panel__header general-panel--red">
          <h5 class="general-panel__header-text">
            <i class="general-panel__header-icon fas fa-minus"></i>
            Unusable: {{ numberImages }}
          </h5>
        </div>

        <ToggleControl
          toggle-id="list-desc"
          closed-text="About this list"
          open-text="- hide -"
          toggle-class="general-panel__toggle-pane general-panel--red"
        >
          <template v-slot:default="slotProps">
            {{ slotProps.togglerText.display }}
          </template>
        </ToggleControl>

        <div class="general-panel__content">
          <b-collapse id="list-desc">
            <div class="general-panel__row general-panel__row--standard-text">
              <p class="font-weight-bold mb-1">Unusable List Overview</p>
              <p>
                This list shows your images that have been determined to be
                unsuitable for print publication.
              </p>
              <p>
                The number in the red button above and in the header of this
                text block is how many images are in this list:
                <strong>{{ numberImages }}</strong>
              </p>
              <p>
                When we're choosing images for a book or calendar project, we
                look in the <strong>Uploads</strong> list of our users. In
                general, we select 40 - 60 images for each project, selecting
                one (1) image each from as many users.
              </p>
              <p>
                We analyze images one by one and either
                <strong>Select</strong> the image for a project or determine
                that the image is <strong>Unusable</strong>.
              </p>
              <p class="font-weight-bold mb-1">Image Guidelines</p>
              <p>
                Since the images you upload will potentially be published in
                print publications, and since we aim to produce high quality
                products, we have to be sure each image meets a certain
                standard.
              </p>
              <p>
                Ensuring each image you upload has many of the characteristics
                we want - and none that we don't! - will greatly increase the
                odds that your image will NOT end up here in the
                <strong>Unusable</strong> list.
              </p>
              <p>
                Image guidelines can be found on the
                <span class="italic">Upload New Image</span> page and on the
                <span class="italic">Replace Image</span> (of an existing
                upload) page. There's a link near the field in which you select
                your image from your device or computer. That link opens an
                overlay window listing the quality characteristics we're lookng
                for.
              </p>
              <p class="font-weight-bold mb-1">
                Possible Reasons for Unusability
              </p>
              <p>
                As we're evaluating images from users'
                <strong>Uploads</strong> list, we make a decision based on the
                standard and guidelines we operate from (see paragraph above).
                Images that do not meet the guidelines will be marked as
                <span class="italic">Unusable</span> and end up here.
              </p>
              <p>
                Possible reasons include: Low resolution, out of focus, too dark
                (there's only so much we can do with Photoshop!),
                artwork/graphics overlay present, undesirable pose of the dog,
                undesirable photo composition (i.e. the dog is too far back in
                the shot, for example), and so on.
              </p>
              <p>
                If we mark an image as <strong>Unusable</strong>, it will no
                longer appear in your Uploads list. Instead, it will show in
                this <strong>Unusable</strong> list.
              </p>
              <p class="font-weight-bold mb-1">Editing/Deleting Images</p>
              <p>
                You cannot edit or delete images in this list. We will keep
                images in this list indefinitely; you can use them for your
                reference to help you with future uploads. That said, from time
                to time, we may delete images in this list at our discretion to
                free up system resources.
              </p>
            </div>
          </b-collapse>
          <div
            v-if="numberImages > 0"
            class="general-panel__row general-panel__row--3col"
          >
            <div>
              <!-- need div since css grid defined on this element ... per <transitiion-group> in ImagesListPending component -->
              <CardImage
                v-for="image in images"
                :key="image.id"
                :image="image"
                :type="type"
                :showHeader="showHeader"
                :showButtonPanel="showButtonPanel"
                :showProductsPanel="showProductsPanel"
                :showRejReason="showRejReason"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleControl from '@/components/layout/ToggleControl';
import CardImage from '@/components/cards/CardImage';
import { mapGetters } from 'vuex';

function sortByCreateTime(dataArray, sortOrder) {
  // If sortOrder is NOT des, set it to empty str (which will be set to default value of 'asc' in following line).
  // With these two lines, we force sortOrder to be one of 'asc' or 'des' no matter what the function is called with.
  sortOrder = sortOrder !== 'des' ? '' : sortOrder;
  sortOrder = sortOrder || 'asc';

  const sortFunction =
    sortOrder === 'asc'
      ? (a, b) => a.creTime - b.creTime
      : (a, b) => b.creTime - a.creTime;
  dataArray.sort(sortFunction);
  return dataArray;
}

export default {
  name: 'ImagesListUnusable',
  components: {
    ToggleControl,
    CardImage,
  },
  data: function () {
    return {
      componentKey: 1,
      type: 'rejected',
      showHeader: true,
      showButtonPanel: false,
      showProductsPanel: false,
      showRejReason: true,
      images: [],
    };
  },
  watch: {
    // If the number of images in this view, e.g. 'pending' images, changes (e.g. one gets put in the 'selected' bin),
    // re-render the view to reflect this.
    numberImages: function () {
      this.rerenderView();
    },
  },
  computed: {
    ...mapGetters('uploadTracker', ['imagesList']),

    numberImages: function () {
      return this.imagesList('Rejected').length;
    },
  },
  methods: {
    rerenderView: function () {
      this.$parent.rerenderView();
    },
  },
  created: function () {
    var rejected = this.imagesList('Rejected');

    // If this route is current route, hitting browser refresh might have the two arrays NOT set yet
    if (rejected) {
      this.images = sortByCreateTime(rejected, 'des');
    }

    var imageNum = 1;
    this.images.forEach((image) => {
      image.imageNum = imageNum;
      imageNum++;
    });
  },
};
</script>

<style>
</style>